import { AppTimeSeriesCubeMetric, CubeTimeDimensionGranularity, Weekdays } from "../../../enum/cube-schema.enum";

export interface GetAppTimeSeriesRequestParamsDto {
    startDate: string;
    endDate: string;
    frequency: CubeTimeDimensionGranularity | Weekdays;
    appId: string;
    metric: AppTimeSeriesCubeMetric;
}